import { Box, Text } from 'wix-style-react';
import * as React from 'react';
export var SubtotalsTitleItem = function (_a) {
    var label = _a.label, value = _a.value, dataHook = _a.dataHook;
    return (React.createElement(Box, { paddingLeft: "4%", paddingRight: "4%", display: "flex", align: "space-between", verticalAlign: "middle", backgroundColor: "#EAF7FF", paddingTop: "6px", height: "36px", borderRadius: "3px" },
        React.createElement(Text, { size: "medium", secondary: true, dataHook: "".concat(dataHook, "-label"), weight: "normal" }, label),
        React.createElement(Text, { dataHook: "".concat(dataHook, "-value"), weight: "bold" }, value)));
};
//# sourceMappingURL=SubtotalsTitleItem.js.map